import React from 'react';

const DataAnalysis = () => {
  return (
    <div className='skills__content'>
      <h3 className="skills__title">Data Analyst</h3>
      <div className="skills__box">
          <div className="skills__group">
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">Python</h3>
                      <span className="skills__level">Advanced</span>
                  </div>
              </div>
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">SQL</h3>
                      <span className="skills__level">Intermediate</span>
                  </div>
              </div>
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">Pandas</h3>
                      <span className="skills__level">Intermediate</span>
                  </div>
              </div>
          </div>
          <div className="skills__group">
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">NumPy</h3>
                      <span className="skills__level">Intermediate</span>
                  </div>
              </div>
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">Power BI</h3>
                      <span className="skills__level">Basic</span>
                  </div>
              </div>
              <div className="skills__data">
                  <i class='bx bx-badge-check'></i>
                  <div>
                      <h3 className="skills__name">Excel</h3>
                      <span className="skills__level">Intermediate</span>
                  </div>
              </div>
          </div>
      </div>
    </div>
  );
};

export default DataAnalysis;